import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import I18n from "i18next";
import { useFormik } from "formik";
import * as yup from "yup";
import MzAlert from "@markaaz/ui/MzAlert";
import MzSpacer from "@markaaz/ui/MzSpacer";
import MzInput from "@markaaz/ui/MzInputControls";
import MzButton from "@markaaz/ui/MzButton";

const sx = {
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    h1: {
      color: "darkBlue.c100",
      fontSize: "24px",
      fontWeight: "600",
      lineHeight: "36px"
    }
  },

  content: {
    display: "flex",
    flexDirection: "column",
    width: "325px",
    alignItems: "center",
    justifyContent: "center"
  },

  caption: {
    color: "darkBlue.c100",
    marginTop: "10px"
  },

  input: {
    margin: "40px 0"
  }
};

const validationSchema = yup.object({
  email: yup.string().email("Enter a valid email id").required("Email is required")
});

export default function ForgotPassword({ onLogin, onSubmit, onAlertClose, showNotification }) {
  const initialValues = {
    email: ""
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async () => {
      await onSubmit(formik.values);
    },
    validationSchema,
    enableReinitialize: true
  });

  return (
    <Box sx={sx.root}>
      <Box sx={sx.content}>
        <MzSpacer />
        <Typography variant="h1">{I18n.t("authPages.recoverPassword")}</Typography>
        <Typography variant="caption" sx={sx.caption}>
          {I18n.t("authPages.recoverDescription")}
        </Typography>

        <MzInput
          sx={sx.input}
          name="email"
          label="Email"
          autoComplete="off"
          noBorder
          fullWidth
          required
          error={!!formik.errors.email}
          helperText={formik.errors.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        ></MzInput>

        <MzButton
          variant="contained"
          color="primary"
          size="large"
          disabled={formik.isSubmitting}
          loading={formik.isSubmitting}
          onClick={formik.handleSubmit}
        >
          {I18n.t("common.submit")}
        </MzButton>
        <MzButton onClick={onLogin}>Back to Sign In</MzButton>
        <MzSpacer />
      </Box>
      <Box mt={2}>
        {showNotification.message && (
          <MzAlert
            sx={{ alignItems: "center", marginTop: "30px", width: "394px" }}
            severity={showNotification.type === "success" ? "success" : "error"}
            onClose={onAlertClose}
          >
            {showNotification.message}
          </MzAlert>
        )}
      </Box>
    </Box>
  );
}
